import {
  Component,
  ElementRef,
  EventEmitter,
  HostListener,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges
} from '@angular/core';
import {GoogleAnalyticsService} from "../../../shared/services/google-analytics/google-analytics.service";
import {Store} from "@ngrx/store";
import * as fromStore from "../../../store";
import {first} from "rxjs/operators";
import {User} from "../../../user/user";
import {combineLatest} from "rxjs";
import {CookieService} from "ngx-cookie";
import {UserService} from "../../../user/user.service";
import {ActivityStatus, IActivity} from "../../../activities/activity";
import {Observable} from "rxjs";

@Component({
    selector: 'db-anniversary-offer',
    templateUrl: './anniversary-offer.component.html',
    styleUrls: ['./anniversary-offer.component.scss'],
    standalone: false
})
export class AnniversaryOfferComponent implements OnInit, OnChanges {
  @Input() hoursLeft: number;
  @Input() daysLeft: number;
  @Input() endDate: number;
  @Input() startDate: number;
  @Input() minutesLeft: number = 59;
  @Output() onTimerEnd = new EventEmitter<void>();
  public ongoingActivity$: Observable<IActivity[]>;

  public isToggled = true;
  public countDownMinutes = 0;
  public countDownUnit = 'h';

  public user: User;
  public userLocalStorage: any;

  constructor(
    private $element: ElementRef,
    private readonly _store: Store<fromStore.DbStoreState>,
    private readonly _googleAnalyticsService: GoogleAnalyticsService,
    private readonly _userService: UserService,
    private readonly _cookieService: CookieService,
  ) { }

  ngOnInit() {
    this._getUserData();
    this._getOngoingActivities();
    this._setHoursToMinutes();
    this._hoursToMinutes();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['hoursLeft'] && changes['hoursLeft'].currentValue) {
      this._hoursToMinutes();
    }
  }

  private _hoursToMinutes(): void {
    if (this.hoursLeft > 24 ) {
      this.countDownUnit = 'd';
      this.hoursLeft = this.daysLeft;
    }
    else if (this.hoursLeft === 1 ) {
      this.countDownUnit = 'm';
      this.hoursLeft = this.minutesLeft;
    }
  }

  private _anniversaryOfferExpire(): void {
    this.userLocalStorage = {...this.userLocalStorage, anniversaryOfferExpired: 'true'};
    this._userService.setToLocal(this.userLocalStorage)
      .pipe(
        first(response => !!response),
      )
      .subscribe(response => {
        if (response.success) {
          this._store.dispatch(new fromStore.LoadUserLocalStorage());
        }
      });
  }

  private _setHoursToMinutes(): void {
    const interval = setInterval(() => {
      this._hoursToMinutes();
      this.hoursLeft -= 1;
      if (this.minutesLeft && this.hoursLeft <= 3) {
        clearInterval(interval);
        this._anniversaryOfferExpire();
        this.onTimerEnd.emit();
      }
    }, 60_000 * (this.hoursLeft === 1 ? 1 : 60));
  }

  private _getUserData(): void {
    combineLatest(
      this._store.select(fromStore.getUser),
      this._store.select(fromStore.getUserLocalStorage),
    ).pipe(
        first(([user]) => !!user)
      )
      .subscribe(([user, userLocalStorage]) => {
        this.user = user;
        this.userLocalStorage = userLocalStorage;
        this.isToggled = !localStorage.getItem('anniversaryOfferBannerHidden' + this.user.id);
      });
  }

  private _getOngoingActivities() {
    this.ongoingActivity$ = this._store.select(fromStore.getOngoingActivities);
    this.ongoingActivity$
      .subscribe((ongoingActivities): void => {
        const ongoingOptimizingActivities = ongoingActivities.find((activity): boolean => activity.status === ActivityStatus.RUNNING && activity.action === 'first_page_is_optimizing');
        if (ongoingOptimizingActivities) {
          this.isToggled = false;
          !this.isToggled && localStorage.setItem('anniversaryOfferBannerHidden' + this.user.id, 'true');
        }
      });
  }

  public toggleBanner(): void {
    this.isToggled = !this.isToggled;
    !this.isToggled && localStorage.setItem('anniversaryOfferBannerHidden' + this.user.id, 'true');
    this.isToggled && this.sendGAEvent('Header button');
  }

  public sendGAEvent(eventAction: string): void {
    const event = {
      eventCategory: 'Anniversary LTO',
      eventAction,
      eventLabel: 'Dashboard',
    };
    this._googleAnalyticsService.sendAnalyticsEventWithCore(event);
  }

  @HostListener('document:click', ['$event']) onDocumentClick($event: any) {
    if (this.isToggled && !this.$element.nativeElement.contains($event.target.parentElement) && !this.$element.nativeElement.contains($event.target.parentElement.parentElement)) {
      this.toggleBanner();
    }
  }

}
